const LoadingSpinner =  () => {
    return(
        <>Carregando...</>
    )
}

export default LoadingSpinner